'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var Tracker = require('./Tracker.js');
var experience_jsReact = require('@ninetailed/experience.js-react');
require('react');
require('@reach/router');



exports.Tracker = Tracker.Tracker;
Object.keys(experience_jsReact).forEach(function (k) {
	if (k !== 'default' && !exports.hasOwnProperty(k)) Object.defineProperty(exports, k, {
		enumerable: true,
		get: function () { return experience_jsReact[k]; }
	});
});
